import { render, staticRenderFns } from "./aboutmodal.vue?vue&type=template&id=d61303ce&scoped=true"
import script from "./aboutmodal.vue?vue&type=script&lang=js"
export * from "./aboutmodal.vue?vue&type=script&lang=js"
import style0 from "./aboutmodal.vue?vue&type=style&index=0&id=d61303ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61303ce",
  null
  
)

export default component.exports